<template>
  <h1>{{ $t('common.404.title') }}</h1>
</template>

<script>
  export default {
    name: 'PageNotFound',
  };
</script>
